import MDBox from "components/MDBox";
import { useMaterialUIController } from "context";
import React, { useEffect, useState } from "react";
import DropZone from "./DropZone";
import AlertSaveCancel from "../AlertsDialogs/AlertSaveCancel";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TypeCOS from "./TypeCOS";
import MDButton from "components/MDButton";
import { useUpdateExtensionsCOSMutation } from "features/hospitalSlice";
import { enqueueSnackbar } from "notistack";

const ClassOfService = ({ setCurrentFolder, currentFolder, folders, type }) => {
  const [controller, dispatch] = useMaterialUIController();
  const { darkMode } = controller;
  const [updateExtensionsCOS] = useUpdateExtensionsCOSMutation();
  const [assignedExtensions, setAssignedExtensions] = useState([]); 
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    if (type != "services") {
      setExpanded(type);
    } else {
      setExpanded(false);
    }
  }, [type]);

  useEffect(() => {
    // instead of this ,  hard code value of 0  will be change later
    if (
      currentFolder?.type != "services" &&
      currentFolder?.children[0]?.type === "services"
    ) {
      setCurrentFolder(currentFolder.children[0]);
    }
  }, []);

  const handleDrop = (data) => {
    console.log("Dropped item:", data);
  };

  const handleCosUpdate = async () => {
    if (!assignedExtensions.length) {
      enqueueSnackbar("No extensions assigned. Cannot update.", {
        variant: "warning",
      });
      return;
    }

    const extensions = assignedExtensions.map((ext) => ext.name);
    const payload = {
      extensions,
      [`${type}Cos`]: currentFolder?.name,
      type: `${type}Cos`,
    };

    try {
      await updateExtensionsCOS(payload).unwrap();
      enqueueSnackbar("Extensions cos updated successfully", {
        variant: "success",
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
    } catch (err) {
      enqueueSnackbar("Failed to update extensions cos", {
        variant: "error",
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
    }
  };

  return (
    <MDBox sx={{ width: "auto" }}>
      {type === "inboundCreate" && (
        <TypeCOS
          type={"inbound"}
          currentFolder={currentFolder}
          isCreated={true}
        />
      )}
      {type === "outboundCreate" && (
        <TypeCOS
          type={"outbound"}
          currentFolder={currentFolder}
          isCreated={true}
        />
      )}
      {(type === "inbound" || type === "outbound") && (
        <>
          <DropZone
            onDrop={handleDrop}
            folders={folders}
            expanded={expanded}
            handleChange={handleChange}
            currentFolder={currentFolder}
            setAssignedExtensions={setAssignedExtensions}
          />
          {(type === "services" || type === "inbound") && (
            <Accordion
              sx={{ bgcolor: "#1e1e1e", marginBottom: "10px" }}
              expanded={expanded === "inbound"}
              onChange={handleChange("inbound")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                aria-controls="panel2-content"
                id="panel2-header"
                sx={{
                  color: "#fff",
                  flexDirection: "row-reverse",
                  gap: 1,
                  fontSize: "16px",
                }}
              >
                Inbound Class of Services
              </AccordionSummary>
              <AccordionDetails>
                <TypeCOS
                  type={"inbound"}
                  currentFolder={currentFolder}
                  isCreated={false}
                />
              </AccordionDetails>
            </Accordion>
          )}
          {(type == "services" || type == "outbound") && (
            <Accordion
              sx={{ bgcolor: "#1e1e1e", marginBottom: "10px" }}
              expanded={expanded === "outbound"}
              onChange={handleChange("outbound")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                aria-controls="panel2-content"
                id="panel2-header"
                sx={{
                  color: "#fff",
                  flexDirection: "row-reverse",
                  gap: 1,
                  fontSize: "16px",
                }}
              >
                Outbound Class of Services
              </AccordionSummary>
              <AccordionDetails>
                <TypeCOS
                  type={"outbound"}
                  currentFolder={currentFolder}
                  isCreated={false}
                />
              </AccordionDetails>
            </Accordion>
          )}
          <MDBox
            sx={{
              display: "flex",
              gap: 2,
              justifyContent: "end",
              // position: "absolute",
              // top: "1.5em",
              // right: "1em",
              // zIndex: 100,
            }}
          >
            <MDButton
              variant="gradient"
              color="success"
              size="medium"
              onClick={handleCosUpdate}
              sx={{ padding: "0px 50px " }}
              disabled={!assignedExtensions.length}
            >
              Update selected extension cos
            </MDButton>
          </MDBox>
        </>
      )}
    </MDBox>
  );
};

export default ClassOfService;
